import React from 'react';

const DownloadApp = () => {
  return <div>DownloadApp</div>;
};

export default DownloadApp;
